module.exports = __webpack_public_path__ + "static/media/03.8c6c5680.svg";